import { z } from "zod";

import { OrganizationSubscriptionDtoSchema } from "../../../dtos/organization-subscriptions";
import { SubscriptionDtoSchema } from "../../../dtos/subscriptions";
import { castToBool } from "../../../utils";

export const GetSubscriptionsQueryParamSchema = z.object({
  all: castToBool.optional(),
});
export type GetSubscriptionsQueryParamType = z.infer<
  typeof GetSubscriptionsQueryParamSchema
>;

export const GetSubscriptionsResponseBodySchema = z.object({
  allSubscriptions: SubscriptionDtoSchema.array(),
  orgSubscriptions: OrganizationSubscriptionDtoSchema.array(),
  planTypes: z.string().array(),
});
export type GetSubscriptionsResponseBodyType = z.infer<
  typeof GetSubscriptionsResponseBodySchema
>;
